import { IValueLabel } from '@/lib/shared/components/Selects/model/value-label';

import { LCPhuketDistrict, LCSamuiDistrict } from '../../domain';

export const selectedIslandHandler = (
  options: IValueLabel[],
  query: {
    phuketDistrict: LCPhuketDistrict[];
    samuiDistrict: LCSamuiDistrict[];
  },
  sq: (
    values: Partial<{
      phuketDistrict: LCPhuketDistrict[] | null;
      samuiDistrict: LCSamuiDistrict[] | null;
    }>
  ) => void
) => {
  if (options.length === 1) {
    if (options[0].value === 'PHUKET') {
      sq({
        phuketDistrict: query.phuketDistrict.length
          ? query.phuketDistrict
          : ['all'],
        samuiDistrict: null,
      });
    } else {
      sq({
        phuketDistrict: null,
        samuiDistrict: query.samuiDistrict.length
          ? query.samuiDistrict
          : ['all'],
      });
    }
  } else if (options.length === 2) {
    if (query.phuketDistrict.length) {
      sq({
        phuketDistrict: query.phuketDistrict,
        samuiDistrict: ['all'],
      });
    } else if (query.samuiDistrict.length) {
      sq({
        phuketDistrict: ['all'],
        samuiDistrict: query.samuiDistrict,
      });
    } else {
      sq({
        phuketDistrict: ['all'],
        samuiDistrict: ['all'],
      });
    }
  } else {
    sq({
      phuketDistrict: null,
      samuiDistrict: null,
    });
  }
};
